import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import { Link } from 'gatsby';
import Randomizer from '../components/randomizer';
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    <h1 {...{
      "id": "pioneer-theatre-company",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h1" {...{
        "href": "#pioneer-theatre-company",
        "aria-label": "pioneer theatre company permalink",
        "className": "anchor before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`Pioneer Theatre Company`}</h1>
    <h2 {...{
      "id": "digital-publications",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h2" {...{
        "href": "#digital-publications",
        "aria-label": "digital publications permalink",
        "className": "anchor before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`Digital Publications`}</h2>
    <blockquote>
      <p parentName="blockquote">{`🔇 We appreciate you silencing your phone.`}</p>
    </blockquote>
    <blockquote>
      <p parentName="blockquote"><strong parentName="p">{`Please tap an image below to view the digital publication.`}</strong></p>
    </blockquote>
    {
      /* *************CURRENT PUBLICATIONS************* */
    }
    {
      /* *************CURRENT PUBLICATIONS************* */
    }
    {
      /* *************CURRENT PUBLICATIONS************* */
    }
    <h3 {...{
      "id": "tonights-show",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h3" {...{
        "href": "#tonights-show",
        "aria-label": "tonights show permalink",
        "className": "anchor before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`Tonight’s Show`}</h3>
    <section className="home-list">
      <Link to="/hello-dolly-2022" alt="Link to Hello Dolly Pioneer Theatre Company digital publication." mdxType="Link">
        <p><span parentName="p" {...{
            "className": "gatsby-resp-image-wrapper",
            "style": {
              "position": "relative",
              "display": "block",
              "marginLeft": "auto",
              "marginRight": "auto",
              "maxWidth": "730px"
            }
          }}>{`
      `}<span parentName="span" {...{
              "className": "gatsby-resp-image-background-image",
              "style": {
                "paddingBottom": "155.83333333333334%",
                "position": "relative",
                "bottom": "0",
                "left": "0",
                "backgroundImage": "url('data:image/png;base64,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')",
                "backgroundSize": "cover",
                "display": "block"
              }
            }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/96dec03be9a90bf33826af3d8ecd038a/8ac56/hello-cover.webp 240w", "/static/96dec03be9a90bf33826af3d8ecd038a/d3be9/hello-cover.webp 480w", "/static/96dec03be9a90bf33826af3d8ecd038a/87ca7/hello-cover.webp 730w"],
                "sizes": "(max-width: 730px) 100vw, 730px",
                "type": "image/webp"
              }}></source>{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/96dec03be9a90bf33826af3d8ecd038a/8ff5a/hello-cover.png 240w", "/static/96dec03be9a90bf33826af3d8ecd038a/e85cb/hello-cover.png 480w", "/static/96dec03be9a90bf33826af3d8ecd038a/e9beb/hello-cover.png 730w"],
                "sizes": "(max-width: 730px) 100vw, 730px",
                "type": "image/png"
              }}></source>{`
          `}<img parentName="picture" {...{
                "className": "gatsby-resp-image-image",
                "src": "/static/96dec03be9a90bf33826af3d8ecd038a/e9beb/hello-cover.png",
                "alt": "Hello Dolly Cover",
                "title": "Hello Dolly Cover",
                "loading": "lazy",
                "style": {
                  "width": "100%",
                  "height": "100%",
                  "margin": "0",
                  "verticalAlign": "middle",
                  "position": "absolute",
                  "top": "0",
                  "left": "0"
                }
              }}></img>{`
        `}</picture>{`
    `}</span></p>
        <div className="homeButtons">Hello Dolly!</div>
      </Link>
      <p><span parentName="p" {...{
          "className": "gatsby-resp-image-wrapper",
          "style": {
            "position": "relative",
            "display": "block",
            "marginLeft": "auto",
            "marginRight": "auto",
            "maxWidth": "730px"
          }
        }}>{`
      `}<span parentName="span" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "155.83333333333334%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAfCAIAAABoLHqZAAAACXBIWXMAAAsTAAALEwEAmpwYAAADrUlEQVQ4y+2U+09aZxzGz5+4yE3u2GYrMofd2iWaTKtr0ovNOmdj52astmqpW1kHHDggCpzzvueOVUTAysWC3A53EaXVZl0AWZq0yZrt1ybPj5/nh/f7Ps+DaKDjPwv5ZP4oaSGqg2gftCEfgdo7aEc6iCqhSwbWxQBHPojq2pAWomqIyaFbCrxiQIgBLgFeNcS+JE3D1MwPzHXkHdSuhs4OKuqiGogNUo9H6J+n2PElbuAZr3HxIgcv/YPTLLBGRAo8IoC3UV8LJVvoT8zYMveVhddifI+Vlayw6vtk/01ybJSeNpArauiQgfUeAJBR6t49ZmSJM/zJq1y8yMrJTKzmF3rwGvz+Cpy+TFsMrNfoZ2diB2PBcA++poKr6vPX2RAz1zfHfnObvjFMzehJ8yXGY/Szgxtbtmz5fnSPLAixei1YKTTPXj19Ge7FrTrSof3nqyTAJwLwM9xj4GC0XgtVC/mTo4NG1ZyM7NZK+ZNGrF4LVApHZ6dYOqGCdh2JqYD93Nz5Bg2wGTm30Dw+PH2dbBxulQVCSNvTcUsq+iAWtKSiS4nQk0TEkU6QQuYy51EAVNsJiRY65ASqBOhSIoylE+7sy1tBlilmXJl9rpjDhVSqUd+tlYXmMVnIbFcKz1J7Ip9FR2KIFjp6CdvtILtZFh5Eg55cEgjpSK3UfHP26s1Z/qSxd1jJHB/F6tVwrezK7G9XC7/uBWS4TQfbZgWBblWEuej2yn4kXCuZ9iOJoxpdyHhzKSydYIu5xXhoevf5fCx4N+xXEKicQDs3a5lluO1hbCdULS0nwrN7gUClcD1A88Xco/jOYjzEFrNE/iB1XC+/bq5lkyKf5QKJtePdzbYSoAPsej/jDlaLvlzKX8o/TkT8pfxfb98uxnc2y/lUoxo9LFKFVC9uVUNXL1gXAQLpRrp1swuk01/K1U+bL2rFzXKWK2Z+DD/3CcJEJKzn/UqK6qNxDcQGSNMoNXWXGUc6/WqJdMiBYzKyY0oeaGnGuLGpZ6HYZ71IPBoiJyeoaw9Zg5lTY7zEyYvNnG6BHUSkwNsDgAgQcujWQbQfLAyBO5P0d/P052ZWubohdfklZu7iPPf1BHNziJ7tJ39TgFVJq2c4Mk5PTjEjy6zewqucfrHTLzHzLfQOc2uYmtWTv8uhu4OKAS4DHgVc7e6BDXnCfTHLXr1BT3xLzV0in8qBWwJ876H2dm3Pm6t5J9ud9vrkcE0NnbruYvS9h35gw7rcv6OfRv9/m/8GlInHq9EDxqcAAAAASUVORK5CYII=')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
              "srcSet": ["/static/c91c75cb8aa4fb9180b1a5822b9ce38d/8ac56/placeholder.webp 240w", "/static/c91c75cb8aa4fb9180b1a5822b9ce38d/d3be9/placeholder.webp 480w", "/static/c91c75cb8aa4fb9180b1a5822b9ce38d/87ca7/placeholder.webp 730w"],
              "sizes": "(max-width: 730px) 100vw, 730px",
              "type": "image/webp"
            }}></source>{`
          `}<source parentName="picture" {...{
              "srcSet": ["/static/c91c75cb8aa4fb9180b1a5822b9ce38d/8ff5a/placeholder.png 240w", "/static/c91c75cb8aa4fb9180b1a5822b9ce38d/e85cb/placeholder.png 480w", "/static/c91c75cb8aa4fb9180b1a5822b9ce38d/e9beb/placeholder.png 730w"],
              "sizes": "(max-width: 730px) 100vw, 730px",
              "type": "image/png"
            }}></source>{`
          `}<img parentName="picture" {...{
              "className": "gatsby-resp-image-image",
              "src": "/static/c91c75cb8aa4fb9180b1a5822b9ce38d/e9beb/placeholder.png",
              "alt": "More coming soon",
              "title": "More coming soon",
              "loading": "lazy",
              "style": {
                "width": "100%",
                "height": "100%",
                "margin": "0",
                "verticalAlign": "middle",
                "position": "absolute",
                "top": "0",
                "left": "0"
              }
            }}></img>{`
        `}</picture>{`
    `}</span></p>
    </section>
    <hr />
    {
      /* *************PAST PUBLICATIONS************* */
    }
    {
      /* *************PAST PUBLICATIONS************* */
    }
    {
      /* *************PAST PUBLICATIONS************* */
    }
    <h3 {...{
      "id": "past-publications",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h3" {...{
        "href": "#past-publications",
        "aria-label": "past publications permalink",
        "className": "anchor before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`Past Publications`}</h3>
    <section className="home-list">
      <Link to="/fireflies-2022" alt="Link to Fireflies Pioneer Theatre Company digital publication." mdxType="Link">
        <p><span parentName="p" {...{
            "className": "gatsby-resp-image-wrapper",
            "style": {
              "position": "relative",
              "display": "block",
              "marginLeft": "auto",
              "marginRight": "auto",
              "maxWidth": "730px"
            }
          }}>{`
      `}<span parentName="span" {...{
              "className": "gatsby-resp-image-background-image",
              "style": {
                "paddingBottom": "156.66666666666666%",
                "position": "relative",
                "bottom": "0",
                "left": "0",
                "backgroundImage": "url('data:image/jpeg;base64,/9j/2wBDABALDA4MChAODQ4SERATGCgaGBYWGDEjJR0oOjM9PDkzODdASFxOQERXRTc4UG1RV19iZ2hnPk1xeXBkeFxlZ2P/2wBDARESEhgVGC8aGi9jQjhCY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2P/wgARCAAfABQDASIAAhEBAxEB/8QAGAAAAwEBAAAAAAAAAAAAAAAAAAIEAQP/xAAYAQACAwAAAAAAAAAAAAAAAAABBAACA//aAAwDAQACEAMQAAABgaijGyGhRlq4aGmAiv8A/8QAGxAAAgMBAQEAAAAAAAAAAAAAAQIAAxIQBBH/2gAIAQEAAQUCA+jMMoGq8Rp5LUrU3qeYQDI5/8QAGBEAAgMAAAAAAAAAAAAAAAAAEBMBETH/2gAIAQMBAT8BXIfWD//EABgRAQADAQAAAAAAAAAAAAAAAAECEBED/9oACAECAQE/AXoDlMIrtf/EABwQAAEDBQAAAAAAAAAAAAAAABAAAiEREiAikf/aAAgBAQAGPwLJ161kRXp//8QAGhABAAMBAQEAAAAAAAAAAAAAAQARIRBBUf/aAAgBAQABPyHU+wljVHkM9tMYgmk28gQqVyNh7bwqQGDh/9oADAMBAAIAAwAAABDMHj7/xAAYEQEAAwEAAAAAAAAAAAAAAAABABARMf/aAAgBAwEBPxAc0j2YGU//xAAXEQADAQAAAAAAAAAAAAAAAAAAARAR/9oACAECAQE/EGgM2uf/xAAdEAEBAAICAwEAAAAAAAAAAAABEQAhEIExQVFh/9oACAEBAAE/ECHcAJkEbW3WJQEAz3j2BKHzhEJPE6x9gzpSTLGBiiQ4IaJ/D1MBos4//9k=')",
                "backgroundSize": "cover",
                "display": "block"
              }
            }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/0dd6f5470b8a2cad53287c9911ae3b1b/8ac56/fireflies_cover.webp 240w", "/static/0dd6f5470b8a2cad53287c9911ae3b1b/d3be9/fireflies_cover.webp 480w", "/static/0dd6f5470b8a2cad53287c9911ae3b1b/87ca7/fireflies_cover.webp 730w"],
                "sizes": "(max-width: 730px) 100vw, 730px",
                "type": "image/webp"
              }}></source>{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/0dd6f5470b8a2cad53287c9911ae3b1b/09b79/fireflies_cover.jpg 240w", "/static/0dd6f5470b8a2cad53287c9911ae3b1b/7cc5e/fireflies_cover.jpg 480w", "/static/0dd6f5470b8a2cad53287c9911ae3b1b/1a144/fireflies_cover.jpg 730w"],
                "sizes": "(max-width: 730px) 100vw, 730px",
                "type": "image/jpeg"
              }}></source>{`
          `}<img parentName="picture" {...{
                "className": "gatsby-resp-image-image",
                "src": "/static/0dd6f5470b8a2cad53287c9911ae3b1b/1a144/fireflies_cover.jpg",
                "alt": "Fireflies Cover",
                "title": "Fireflies Cover",
                "loading": "lazy",
                "style": {
                  "width": "100%",
                  "height": "100%",
                  "margin": "0",
                  "verticalAlign": "middle",
                  "position": "absolute",
                  "top": "0",
                  "left": "0"
                }
              }}></img>{`
        `}</picture>{`
    `}</span></p>
        <div className="homeButtons">Fireflies</div>
      </Link>
      <Link to="/something-rotten-2022" alt="Link to Something Rotten Pioneer Theatre Company digital publication." mdxType="Link">
        <p><span parentName="p" {...{
            "className": "gatsby-resp-image-wrapper",
            "style": {
              "position": "relative",
              "display": "block",
              "marginLeft": "auto",
              "marginRight": "auto",
              "maxWidth": "730px"
            }
          }}>{`
      `}<span parentName="span" {...{
              "className": "gatsby-resp-image-background-image",
              "style": {
                "paddingBottom": "155.83333333333334%",
                "position": "relative",
                "bottom": "0",
                "left": "0",
                "backgroundImage": "url('data:image/jpeg;base64,/9j/2wBDABALDA4MChAODQ4SERATGCgaGBYWGDEjJR0oOjM9PDkzODdASFxOQERXRTc4UG1RV19iZ2hnPk1xeXBkeFxlZ2P/2wBDARESEhgVGC8aGi9jQjhCY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2P/wgARCAAfABQDASIAAhEBAxEB/8QAGAAAAwEBAAAAAAAAAAAAAAAAAAECBQP/xAAYAQADAQEAAAAAAAAAAAAAAAABAgMABP/aAAwDAQACEAMQAAAB6ubzZYHQmks5yMklh//EABwQAAIBBQEAAAAAAAAAAAAAAAECAAMREiExQf/aAAgBAQABBQIKCHTFWnKbm6N0HRIsdzI28n//xAAYEQACAwAAAAAAAAAAAAAAAAAAEQEQIf/aAAgBAwEBPwHESOv/xAAaEQACAgMAAAAAAAAAAAAAAAAAARESAiEx/9oACAECAQE/AZdjHhTciP/EABkQAAIDAQAAAAAAAAAAAAAAABARAAEgIf/aAAgBAQAGPwKPurQR/8QAHRABAAICAgMAAAAAAAAAAAAAAQARITFBURCBkf/aAAgBAQABPyEit29QlH1Niq1xFbBcNkbY+5WlFYggu8dStDe7jEUcTk2pjrfj/9oADAMBAAIAAwAAABDA4fz/xAAZEQADAAMAAAAAAAAAAAAAAAAAAREhMWH/2gAIAQMBAT8Q4GxTUHk//8QAGREAAwEBAQAAAAAAAAAAAAAAAAERMSFB/9oACAECAQE/EMl5TElUXokUR//EAB0QAAICAgMBAAAAAAAAAAAAAAERACExQVFhgaH/2gAIAQEAAT8QKcJFR831iFoI4ootQAuTiZZodEGvMzQ4Bos1OpOknAWAks7CPWYlk+Q4KCA0rjXG1BNCMxukaLjPM//Z')",
                "backgroundSize": "cover",
                "display": "block"
              }
            }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/792cbc3d41ea926c1916c0e486b0b732/8ac56/Something_Rotten_Cover.webp 240w", "/static/792cbc3d41ea926c1916c0e486b0b732/d3be9/Something_Rotten_Cover.webp 480w", "/static/792cbc3d41ea926c1916c0e486b0b732/87ca7/Something_Rotten_Cover.webp 730w"],
                "sizes": "(max-width: 730px) 100vw, 730px",
                "type": "image/webp"
              }}></source>{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/792cbc3d41ea926c1916c0e486b0b732/09b79/Something_Rotten_Cover.jpg 240w", "/static/792cbc3d41ea926c1916c0e486b0b732/7cc5e/Something_Rotten_Cover.jpg 480w", "/static/792cbc3d41ea926c1916c0e486b0b732/1a144/Something_Rotten_Cover.jpg 730w"],
                "sizes": "(max-width: 730px) 100vw, 730px",
                "type": "image/jpeg"
              }}></source>{`
          `}<img parentName="picture" {...{
                "className": "gatsby-resp-image-image",
                "src": "/static/792cbc3d41ea926c1916c0e486b0b732/1a144/Something_Rotten_Cover.jpg",
                "alt": "Messenger Cover",
                "title": "Messenger Cover",
                "loading": "lazy",
                "style": {
                  "width": "100%",
                  "height": "100%",
                  "margin": "0",
                  "verticalAlign": "middle",
                  "position": "absolute",
                  "top": "0",
                  "left": "0"
                }
              }}></img>{`
        `}</picture>{`
    `}</span></p>
        <div className="homeButtons">Something Rotten!</div>
      </Link>
      <Link to="/messenger-2022" alt="Link to Messenger Pioneer Theatre Company publication." mdxType="Link">
        <p><span parentName="p" {...{
            "className": "gatsby-resp-image-wrapper",
            "style": {
              "position": "relative",
              "display": "block",
              "marginLeft": "auto",
              "marginRight": "auto",
              "maxWidth": "730px"
            }
          }}>{`
      `}<span parentName="span" {...{
              "className": "gatsby-resp-image-background-image",
              "style": {
                "paddingBottom": "155.83333333333334%",
                "position": "relative",
                "bottom": "0",
                "left": "0",
                "backgroundImage": "url('data:image/jpeg;base64,/9j/2wBDABALDA4MChAODQ4SERATGCgaGBYWGDEjJR0oOjM9PDkzODdASFxOQERXRTc4UG1RV19iZ2hnPk1xeXBkeFxlZ2P/2wBDARESEhgVGC8aGi9jQjhCY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2P/wgARCAAfABQDASIAAhEBAxEB/8QAGAABAAMBAAAAAAAAAAAAAAAAAAEDBQT/xAAXAQEBAQEAAAAAAAAAAAAAAAAAAwEE/9oADAMBAAIQAxAAAAHoKzPS6c0GckrSq//EABoQAAIDAQEAAAAAAAAAAAAAAAASAQIRIRD/2gAIAQEAAQUCbByxeIM7Ykbg8r5//8QAFBEBAAAAAAAAAAAAAAAAAAAAIP/aAAgBAwEBPwEf/8QAFREBAQAAAAAAAAAAAAAAAAAAEBL/2gAIAQIBAT8BIP/EABoQAAMAAwEAAAAAAAAAAAAAAAABERAgMXH/2gAIAQEABj8CIxeHCi0lz//EABwQAQADAAMBAQAAAAAAAAAAAAEAESEQMWFBcf/aAAgBAQABPyH22bbNfIhxXTqZmN+EO/iW2FGPCtqqKfF4/9oADAMBAAIAAwAAABB7xvL/xAAWEQEBAQAAAAAAAAAAAAAAAAAREAH/2gAIAQMBAT8QdYz/xAAYEQADAQEAAAAAAAAAAAAAAAAAAREQMf/aAAgBAgEBPxBJQRzLn//EAB0QAQACAwADAQAAAAAAAAAAAAEAESExQVFhobH/2gAIAQEAAT8Qv0p1ILQVo6xHqDst++5uArEEQCw7PUooTXRUSUql3nkqFxqcIGQOrdR9Z/x+y3zP/9k=')",
                "backgroundSize": "cover",
                "display": "block"
              }
            }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/71fa082458fa27cc0f2f61dc55e641a2/8ac56/messenger-cover.webp 240w", "/static/71fa082458fa27cc0f2f61dc55e641a2/d3be9/messenger-cover.webp 480w", "/static/71fa082458fa27cc0f2f61dc55e641a2/87ca7/messenger-cover.webp 730w"],
                "sizes": "(max-width: 730px) 100vw, 730px",
                "type": "image/webp"
              }}></source>{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/71fa082458fa27cc0f2f61dc55e641a2/09b79/messenger-cover.jpg 240w", "/static/71fa082458fa27cc0f2f61dc55e641a2/7cc5e/messenger-cover.jpg 480w", "/static/71fa082458fa27cc0f2f61dc55e641a2/1a144/messenger-cover.jpg 730w"],
                "sizes": "(max-width: 730px) 100vw, 730px",
                "type": "image/jpeg"
              }}></source>{`
          `}<img parentName="picture" {...{
                "className": "gatsby-resp-image-image",
                "src": "/static/71fa082458fa27cc0f2f61dc55e641a2/1a144/messenger-cover.jpg",
                "alt": "Messenger Cover",
                "title": "Messenger Cover",
                "loading": "lazy",
                "style": {
                  "width": "100%",
                  "height": "100%",
                  "margin": "0",
                  "verticalAlign": "middle",
                  "position": "absolute",
                  "top": "0",
                  "left": "0"
                }
              }}></img>{`
        `}</picture>{`
    `}</span></p>
        <div className="homeButtons">The Messenger</div>
      </Link>
      <Link to="/elf-2021" alt="Link to ELF 2021 Pioneer Theatre Company publication." mdxType="Link">
        <p><span parentName="p" {...{
            "className": "gatsby-resp-image-wrapper",
            "style": {
              "position": "relative",
              "display": "block",
              "marginLeft": "auto",
              "marginRight": "auto",
              "maxWidth": "730px"
            }
          }}>{`
      `}<span parentName="span" {...{
              "className": "gatsby-resp-image-background-image",
              "style": {
                "paddingBottom": "155.83333333333334%",
                "position": "relative",
                "bottom": "0",
                "left": "0",
                "backgroundImage": "url('data:image/jpeg;base64,/9j/2wBDABALDA4MChAODQ4SERATGCgaGBYWGDEjJR0oOjM9PDkzODdASFxOQERXRTc4UG1RV19iZ2hnPk1xeXBkeFxlZ2P/2wBDARESEhgVGC8aGi9jQjhCY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2P/wgARCAAfABQDASIAAhEBAxEB/8QAGQAAAwEBAQAAAAAAAAAAAAAAAAEDAgQF/8QAFwEAAwEAAAAAAAAAAAAAAAAAAQIDAP/aAAwDAQACEAMQAAAB9l8FAtBDVrk1kYgU/8QAGhAAAwADAQAAAAAAAAAAAAAAAAECEBIiEf/aAAgBAQABBQLw2kSLdaQupGkTMzR1tj//xAAWEQEBAQAAAAAAAAAAAAAAAAAQERL/2gAIAQMBAT8Bpk//xAAWEQEBAQAAAAAAAAAAAAAAAAAQESH/2gAIAQIBAT8Bph//xAAcEAABBAMBAAAAAAAAAAAAAAAAARARIQIxMnL/2gAIAQEABj8ClRL22ayYeBaOZkpG3RLf/8QAHhABAAICAgMBAAAAAAAAAAAAAQARIVEQMUFhcYH/2gAIAQEAAT8hoFlBETBp7jZy9xGBLSr0zzPW0CfSZyFdphCPAC35VKztx//aAAwDAQACAAMAAAAQK9FM/8QAFxEBAAMAAAAAAAAAAAAAAAAAEAERIf/aAAgBAwEBPxCNFz//xAAXEQEAAwAAAAAAAAAAAAAAAAABABAh/9oACAECAQE/ENsbf//EACEQAQACAgEDBQAAAAAAAAAAAAEAESFBMVFhcYGRobHR/9oACAEBAAE/EBMeQrEY8v8ACDLrac68Zjbo7KUVRXP7CRzUdtkAtS27z3l7kQgC+8SY0lmhM6hxEKC76h6xH3LlY5Z//9k=')",
                "backgroundSize": "cover",
                "display": "block"
              }
            }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/c110634987276b44050df28ea5ba29c8/8ac56/elf-cover.webp 240w", "/static/c110634987276b44050df28ea5ba29c8/d3be9/elf-cover.webp 480w", "/static/c110634987276b44050df28ea5ba29c8/87ca7/elf-cover.webp 730w"],
                "sizes": "(max-width: 730px) 100vw, 730px",
                "type": "image/webp"
              }}></source>{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/c110634987276b44050df28ea5ba29c8/09b79/elf-cover.jpg 240w", "/static/c110634987276b44050df28ea5ba29c8/7cc5e/elf-cover.jpg 480w", "/static/c110634987276b44050df28ea5ba29c8/1a144/elf-cover.jpg 730w"],
                "sizes": "(max-width: 730px) 100vw, 730px",
                "type": "image/jpeg"
              }}></source>{`
          `}<img parentName="picture" {...{
                "className": "gatsby-resp-image-image",
                "src": "/static/c110634987276b44050df28ea5ba29c8/1a144/elf-cover.jpg",
                "alt": "Elf 2021 Cover",
                "title": "Elf 2021 Cover",
                "loading": "lazy",
                "style": {
                  "width": "100%",
                  "height": "100%",
                  "margin": "0",
                  "verticalAlign": "middle",
                  "position": "absolute",
                  "top": "0",
                  "left": "0"
                }
              }}></img>{`
        `}</picture>{`
    `}</span></p>
        <div className="homeButtons">Elf Digital Publication</div>
      </Link>
      <Link to="/ass-2021" alt="Link to Fall 2021 Pioneer Theatre Company publication." mdxType="Link">
        <p><span parentName="p" {...{
            "className": "gatsby-resp-image-wrapper",
            "style": {
              "position": "relative",
              "display": "block",
              "marginLeft": "auto",
              "marginRight": "auto",
              "maxWidth": "730px"
            }
          }}>{`
      `}<span parentName="span" {...{
              "className": "gatsby-resp-image-background-image",
              "style": {
                "paddingBottom": "155.83333333333334%",
                "position": "relative",
                "bottom": "0",
                "left": "0",
                "backgroundImage": "url('data:image/jpeg;base64,/9j/2wBDABALDA4MChAODQ4SERATGCgaGBYWGDEjJR0oOjM9PDkzODdASFxOQERXRTc4UG1RV19iZ2hnPk1xeXBkeFxlZ2P/2wBDARESEhgVGC8aGi9jQjhCY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2P/wgARCAAfABQDASIAAhEBAxEB/8QAGAAAAwEBAAAAAAAAAAAAAAAAAAECAwT/xAAXAQEAAwAAAAAAAAAAAAAAAAADAQIE/9oADAMBAAIQAxAAAAHtz1iayA+elLNWUIP/xAAZEAEAAwEBAAAAAAAAAAAAAAABABEhEBL/2gAIAQEAAQUCAlaccCXFwKnna5//xAAWEQEBAQAAAAAAAAAAAAAAAAAQARL/2gAIAQMBAT8BNw//xAAVEQEBAAAAAAAAAAAAAAAAAAAQEv/aAAgBAgEBPwEg/8QAFhAAAwAAAAAAAAAAAAAAAAAAEDAx/9oACAEBAAY/Ak0//8QAHBAAAgIDAQEAAAAAAAAAAAAAAAERITFBYRBR/9oACAEBAAE/IW8pDWVUbZyP4nDJolyTh3sdtnYWBNwI5vz/2gAMAwEAAgADAAAAENghA//EABgRAAMBAQAAAAAAAAAAAAAAAAABERAx/9oACAEDAQE/EHZB9Hh//8QAFhEBAQEAAAAAAAAAAAAAAAAAERAB/9oACAECAQE/EMFin//EAB0QAQADAQACAwAAAAAAAAAAAAEAESExEGFBweH/2gAIAQEAAT8Q7K9sMwAYbC1rp2FLxGeoVrj1IRYm0lxN38pci1gfsGgbtuAapd5X3G86Bm+P/9k=')",
                "backgroundSize": "cover",
                "display": "block"
              }
            }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/f59c3f50e76fe1506ee7d7f3d495fd2e/8ac56/ass-cover.webp 240w", "/static/f59c3f50e76fe1506ee7d7f3d495fd2e/d3be9/ass-cover.webp 480w", "/static/f59c3f50e76fe1506ee7d7f3d495fd2e/87ca7/ass-cover.webp 730w"],
                "sizes": "(max-width: 730px) 100vw, 730px",
                "type": "image/webp"
              }}></source>{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/f59c3f50e76fe1506ee7d7f3d495fd2e/09b79/ass-cover.jpg 240w", "/static/f59c3f50e76fe1506ee7d7f3d495fd2e/7cc5e/ass-cover.jpg 480w", "/static/f59c3f50e76fe1506ee7d7f3d495fd2e/1a144/ass-cover.jpg 730w"],
                "sizes": "(max-width: 730px) 100vw, 730px",
                "type": "image/jpeg"
              }}></source>{`
          `}<img parentName="picture" {...{
                "className": "gatsby-resp-image-image",
                "src": "/static/f59c3f50e76fe1506ee7d7f3d495fd2e/1a144/ass-cover.jpg",
                "alt": "Ass 2021 Cover",
                "title": "Ass 2021 Cover",
                "loading": "lazy",
                "style": {
                  "width": "100%",
                  "height": "100%",
                  "margin": "0",
                  "verticalAlign": "middle",
                  "position": "absolute",
                  "top": "0",
                  "left": "0"
                }
              }}></img>{`
        `}</picture>{`
    `}</span></p>
  <div className="homeButtons">Ass Digital Publication</div>
      </Link>
      <Link to="/misbehavin-2021" alt="Link to 2021 Pioneer Theatre publication." mdxType="Link">
        <p><span parentName="p" {...{
            "className": "gatsby-resp-image-wrapper",
            "style": {
              "position": "relative",
              "display": "block",
              "marginLeft": "auto",
              "marginRight": "auto",
              "maxWidth": "730px"
            }
          }}>{`
      `}<span parentName="span" {...{
              "className": "gatsby-resp-image-background-image",
              "style": {
                "paddingBottom": "155.83333333333334%",
                "position": "relative",
                "bottom": "0",
                "left": "0",
                "backgroundImage": "url('data:image/jpeg;base64,/9j/2wBDABALDA4MChAODQ4SERATGCgaGBYWGDEjJR0oOjM9PDkzODdASFxOQERXRTc4UG1RV19iZ2hnPk1xeXBkeFxlZ2P/2wBDARESEhgVGC8aGi9jQjhCY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2P/wgARCAAfABQDASIAAhEBAxEB/8QAGAAAAwEBAAAAAAAAAAAAAAAAAAECAwX/xAAXAQADAQAAAAAAAAAAAAAAAAAAAgMB/9oADAMBAAIQAxAAAAHnRu2KGVMHUoMZbP/EABsQAAICAwEAAAAAAAAAAAAAAAECABEDEBIh/9oACAEBAAEFAl9JhmNbXKgBMGSg7dapea1//8QAFREBAQAAAAAAAAAAAAAAAAAAEBH/2gAIAQMBAT8BKf/EABcRAQEBAQAAAAAAAAAAAAAAAAEAAhD/2gAIAQIBAT8BiMPP/8QAGhAAAgMBAQAAAAAAAAAAAAAAAREAECFBMf/aAAgBAQAGPwLgs44Vw7SUb015t//EAB0QAAICAgMBAAAAAAAAAAAAAAERADEhQRBRgaH/2gAIAQEAAT8hrYFkmWFeQxiqhkRZeTalTTXOoYSMdbjrgSMjgkT6RK4//9oADAMBAAIAAwAAABBLCTD/xAAYEQADAQEAAAAAAAAAAAAAAAAAAREQMf/aAAgBAwEBPxCKUY25c//EABgRAQADAQAAAAAAAAAAAAAAABEAARAh/9oACAECAQE/EG2AljoZ/8QAHRABAAMBAQADAQAAAAAAAAAAAQARITFBUWGBkf/aAAgBAQABPxC3DE8YH5NsKOYqcfyupdsehoHUjClAYql4hK3UOOEMxnSkR9xbIMA2W3uT2BAwVvH8gAWa+Ll7wn//2Q==')",
                "backgroundSize": "cover",
                "display": "block"
              }
            }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/a05a38ba8a6bbc4c20d300c324e64c34/8ac56/Misbehavin_Cover.webp 240w", "/static/a05a38ba8a6bbc4c20d300c324e64c34/d3be9/Misbehavin_Cover.webp 480w", "/static/a05a38ba8a6bbc4c20d300c324e64c34/87ca7/Misbehavin_Cover.webp 730w"],
                "sizes": "(max-width: 730px) 100vw, 730px",
                "type": "image/webp"
              }}></source>{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/a05a38ba8a6bbc4c20d300c324e64c34/09b79/Misbehavin_Cover.jpg 240w", "/static/a05a38ba8a6bbc4c20d300c324e64c34/7cc5e/Misbehavin_Cover.jpg 480w", "/static/a05a38ba8a6bbc4c20d300c324e64c34/1a144/Misbehavin_Cover.jpg 730w"],
                "sizes": "(max-width: 730px) 100vw, 730px",
                "type": "image/jpeg"
              }}></source>{`
          `}<img parentName="picture" {...{
                "className": "gatsby-resp-image-image",
                "src": "/static/a05a38ba8a6bbc4c20d300c324e64c34/1a144/Misbehavin_Cover.jpg",
                "alt": "Aint Misbehavin 2021 Cover",
                "title": "Aint Misbehavin 2021 Cover",
                "loading": "lazy",
                "style": {
                  "width": "100%",
                  "height": "100%",
                  "margin": "0",
                  "verticalAlign": "middle",
                  "position": "absolute",
                  "top": "0",
                  "left": "0"
                }
              }}></img>{`
        `}</picture>{`
    `}</span></p>
  <div className="homeButtons">Ain’t Misbehavin’ Digital Publication</div>
      </Link>
    </section>
    <br />
    <br />
    <hr />
    <br />
    <p>
  Enjoy productions just leaving Broadway, Utah premieres, new works, and more.
  Pioneer Theatre Company produces plays and musicals not seen anywhere else in
  Utah.
    </p>
    <Randomizer mdxType="Randomizer" />

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      